module.exports = __webpack_public_path__ + "static/media/builder.e69976b0.svg";